import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PurchasePriceListReferenceService extends BaseReferenceService {
  constructor() {
    super('PurchasePriceListReference');
  }
}
